import React, { useState, useContext, useEffect } from "react";
import "../Styles/MemberProfilePage.css"; // Import CSS styles
import { useNavigate } from "react-router-dom";
import MpCoverImageUploader from "../Utils/CoverImageUploader";
import UPFeedContent from "../Utils/UserPickFeed/UserPickFeedData.js";
import { ThemeContext } from "../../../../context/ThemeContext";
import POProfileImageUploader from "../Utils/ProfileImageUploader.js";
import { fetchUPFeedData } from "../Utils/UserPickFeed/UserPickFetchData";


const UserPickModule = ({ userId }) => {
  const { theme } = useContext(ThemeContext);
  const [profileImage, setProfileImage] = useState(null);
  const [location, setLocation] = useState(null);
  const navigate = useNavigate();
  const [fullName, setFullName] = useState("");
  const [feedData, setFeedData] = useState({});

  useEffect(() => {
    import(`../Styles/themes/${theme}/themes.css`).then(() => {
      console.log(`Loaded ${theme} styles for UserProfile`);
    }).catch(() => {
      console.error(`Theme CSS not found for ${theme}`);
    });
  }, [theme]);

    useEffect(() => {
      const loadProfileData = async () => {
        const profileData = await fetchUPFeedData(userId);
        if (profileData) {
          setProfileImage(profileData.profileImage);
          setLocation(profileData.location);
          setFeedData(profileData);
    
          // ✅ Build full name safely
          setFullName(profileData.userId);
        }
      };
    
      if (userId) {
        loadProfileData();
      }
    }, [userId]);

  return (
    <div className="mp-page-grid">
      <div className="mp-page-grid-upper">
      <POProfileImageUploader
          fullName={feedData.userName}
          profileImage={profileImage}
          location={location}
        />
      </div>

      <div className="mp-page-grid-lower" style={{marginTop: 5}}>
        <UPFeedContent userId={userId}/>
      </div>
        <div>
          <p className="mp-copyright" style={{marginTop: 20}}>
            Oowlet - A Hybrid Model Social Network, Copyright © InitiumNet Technology Pvt Ltd.
          </p>
        </div>
    </div>
  );
};

export default UserPickModule;

